/* 常用的基础数据查询封装
例如：获取货币种类 */
import XEUtils from 'xe-utils/methods/xe-utils';
import { MessageBox } from 'element-ui';
import store from '../../store';
import httpService from '@/service/http-service';
import BASE_API from '@/api/dataBase';
import SYSCONFIG_API from '@/api/systemManage/sysConfig';
import COM_API from '@/api/masterData/company';
import DICTAPI from '@/api/systemManage/dict';
import loading from '@/common/js/load.js'; //loading
// import BANK_API from '@/api/masterData/bank';
// import BANK_ACCOUNT_API from '@/api/financeCenter/bankAccount';
import { dateFormatter, alert } from '@/common/js/util';
import { confirm as confirmBox } from './util';
// import { utils } from 'sortablejs';
// import Vue from 'vue';
import globalVar from '@/common/js/global';
import LOGISTICS from '../../api/reportCenter/logistics';
import { fmoney } from '@/common/js/util';

const alertErr = (message) => {
  MessageBox.alert(
    "<div><img src='./static/img/error.png'/><div class='confirmTitle'>" +
      '操作失败！' +
      '</div>' +
      "<div class='confirmContent'>" +
      message +
      '</div></div>',
    '',
    {
      dangerouslyUseHTMLString: true,
      center: true,
      confirmButtonText: '确定',
    }
  );
};

export default {
  linkRouteUrl(path, name, title, query) {
    let routepath = {
      path: path,
      name: name,
      meta: {
        keepAlive: true,
        title: title,
      },
    };
    if (query) {
      routepath.query = query;
    }
    store.dispatch('tagsView/addTabView', routepath).then(() => {
      this.$nextTick(() => {
        this.$router.push(routepath);
      });
    });
  },
  linkBackRouteUrl(fromPath, fromName, fromTitle, toPath, toName, toTitle) {
    let pathList = {
      fromPath: {
        path: fromPath,
        name: fromName,
        meta: { keepAlive: true, title: fromTitle },
      },
      toPath: {
        path: toPath,
        name: toName,
        meta: { title: toTitle },
      },
    };
    store.dispatch('tagsView/backTabView', pathList).then(() => {
      this.$nextTick(() => {
        this.$router.push(pathList.toPath);
      });
    });
  },
  //获取币种
  async getCurrency(params = { isEnabled: 1 }) {
    // 获取币别
    let result = await httpService.get(BASE_API.LIST_CURRENCY, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //通过公司获取 账套
  async getLedger(val) {
    // 根据tenantCode获取公司列表
    let result = await httpService.post(BASE_API.GET_LEDGER, { companyCode: val });
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //获取科目列表--通过账套获取
  async getAccountListByLedgerCode(ledgerCode) {
    let result = await httpService.post(BASE_API.GET_ACCOUNTDETAIL, { ledgerCode });
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //获取科目列表--通过公司获取
  async getAccountListByCompanyCode(ledgerEntityCode) {
    let result = await httpService.post(BASE_API.GET_ACCOUNTDETAIL, { ledgerEntityCode });
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //获取公司列表 默认查询当前集团
  async getCompanyList() {
    // 根据tenantCode获取公司列表
    let result = await httpService.get(
      BASE_API.LISTDATA_SERECHCOMPANY + `/${store.state.userInfo.userInfo.tenantCode}`
    );
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //获取公司树  默认查询当前集团可用状态
  async getCompanyListTree(params) {
    if (!params) {
      params = {
        belongTenantCode: store.state.userInfo.userInfo.tenantCode,
        currentStatus: 0,
      };
    }
    let result = await httpService.post(BASE_API.LISTDATA_SERECHCOMPANYTREE, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //根据公司获取部门列表
  async getDepartment(companyCode) {
    let result = await httpService.post(BASE_API.LIST_DEPARTMENT_API + '/' + companyCode);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //根据公司获取部门树
  async getDepartmentTree(params) {
    if (!params) {
      params = {
        tenantCode: store.state.userInfo.userInfo.tenantCode,
        adminFlag: store.state.userInfo.userInfo.adminFlag,
      };
    }
    let result = await httpService.post(COM_API.LIST_COMPANY_API, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //根据公司获取控制范围部门树
  async getListControlAreaDepartmentTree(params) {
    if (!params) {
      params = {
        tenantCode: store.state.userInfo.userInfo.tenantCode,
        adminFlag: store.state.userInfo.userInfo.adminFlag,
      };
    }
    let result = await httpService.post(BASE_API.LIST_COMPANY_API, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //查询银行列表
  async getMDBank(params) {
    let result = await httpService.post(BASE_API.GET_LIST_BANK, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //查询分行列表
  async getBankBranch(params) {
    let result = await httpService.post(BASE_API.GET_LIST_BANKBRANCH, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //查询银行账号列表 默认为已生效状态
  async getBankAccount(params) {
    if (!params) {
      params = { bankAccountStatus: '001' };
    }
    let result = await httpService.post(BASE_API.GET_LIST_BANKACCOUNT, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  //获取商品分类树 集团商品类别（原来字典表：group_category）
  async getProductCategoryTree(params) {
    let result = await httpService.get(BASE_API.GET_LIST_PRODUCT_CAT_TREE, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 获取汇率-- 汇率有个拦截器--公司汇率取当月第一天
  async getRate(params) {
    let exchangeRate = 1;
    if (!Object.prototype.hasOwnProperty.call(params, 'fromCurrencyCode')) {
      params['fromCurrencyCode'] = 'CNY';
    }
    if (!Object.prototype.hasOwnProperty.call(params, 'toCurrencyCode')) {
      params['toCurrencyCode'] = 'CNY';
    }
    if (!Object.prototype.hasOwnProperty.call(params, 'exchangeDate')) {
      params['exchangeDate'] = new Date().toLocaleDateString().replace(/\//g, '-');
    }
    if (params.fromCurrencyCode === params.toCurrencyCode) {
      // 为人民币时汇率为1
      return { negativeRate: 1, positiveRate: 1 };
    }
    let result = await httpService.post(BASE_API.GET_CURRENCY_EXCHANGE, params);
    if (result.data.data) {
      exchangeRate = result.data.data;
      //negativeRate 逆向汇率
      //positiveRate 正向汇率
      return exchangeRate;
    } else {
      // 没获取到汇率，选择默认人民币
      // exchangeRate = 1;
      alert(result.data.msg);
      return false;
    }
  },

  // 获取税率
  async getTaxRate(params = {}) {
    let result = await httpService.post(BASE_API.QUERY_TAX_RATE, params);
    if (0 == result.data.code) {
      let list = result.data.data;
      list.map((it) => {
        // OT时 taxCode为空字符串 会直接默认该值
        it['value'] = it.taxCode || '999';
        it['label'] = it.taxName;
        return it;
      });
      return list;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 获取人员主数据人员列表
  async getPerson(params = {}) {
    let result = await httpService.post(BASE_API.GET_PERSON_API, params);
    if (0 == result.data.code) {
      return result.data.data.personInfo;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 获取模块
  async getTAeApplication(params = {}) {
    let result = await httpService.post(BASE_API.QUERY_TAE_APPLICATION, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 获取凭证类型
  async getSapVouScherType(params = {}) {
    let result = await httpService.post(BASE_API.QUERY_SAP_VOUCHER_TYPE, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 生成凭证
  async genarateVoucher(flag, params = {}) {
    let api = flag + BASE_API.GENARATE_VOUCHER;
    loading.startLoading();
    let result = await httpService.post(api, params);
    loading.endLoading();
    if (0 == result.data.code) {
      return result;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 查询凭证
  async queryAccountEntry(params = {}) {
    let result = await httpService.post(BASE_API.QUERY_VOUCHER, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 费用类型  大类："leafFlag":"N"，小类："leafFlag":"Y"
  async getExpenseType(params = {}) {
    let result = await httpService.post(BASE_API.GET_EXPENSETYPE, params);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 费用类型
  async getExpenseTypeFormat() {
    let result = await httpService.post(BASE_API.GET_EXPENSETYPE_FORMAT);
    if (0 == result.data.code) {
      return result.data.data;
    } else {
      alertErr(result.data.msg);
    }
  },

  // 合并业务字段
  assignObj(obj, flag = 0) {
    //flag为1时 不管有没有ID都添加业务字段
    if (obj['id'] && !flag) return obj;
    let baseData = {
      tenantCode: store.state.userInfo.userInfo.tenantCode,
      companyCode: store.state.userInfo.userInfo.companyCode,
      departmentCode: store.state.userInfo.userInfo.departmentCode,
      companyName: store.state.userInfo.userInfo.companyName,
      departmentName: store.state.userInfo.userInfo.departmentName,
      userId: store.state.userInfo.userInfo.userCode,
    };
    return { ...obj, ...baseData };
  },

  //根据dictType获取dictList
  getDictListByType(type) {
    if (store.state.dict.dictList.length > 10) {
      let dictObj = store.state.dict.dictList.find((it) => it.dictType == type);
      return dictObj ? dictObj.dictList : [];
    } else {
      return [];
    }
  },

  //根据dictType获取dictListMap
  getDictListMapByType(type) {
    let dictObj = XEUtils.clone(store.state.dict.dictListMap[type], true);
    return dictObj;
  },

  //根据dictType获取dictList
  getDictValueByType(type, dictValue) {
    let dictObj = this.getDictListMapByType(type);
    if (!dictObj) return dictValue;
    let tempValue = dictObj.find((it) => it.value == dictValue);
    if (tempValue != null) {
      return tempValue.label;
    } else {
      return dictValue || '';
    }
  },

  // 字典集合 map对象
  async getAllDictMap() {
    loading.startLoading();
    let result = await httpService.post(DICTAPI.GET_ALLDICT_MAP, { isDeleted: 0 });
    loading.endLoading();
    if (result.data.code == 0) {
      localStorage.removeItem('dictListMap');
      store.dispatch('dict/setDictListMap', result.data.data);
      localStorage.setItem('dictListMap', JSON.stringify(result.data.data));
    } else {
      alertErr('获取配置字典失败！请刷新浏览器或联系管理员。');
    }
  },

  // 将金额转换成2位小数（四舍五入）
  formatTableColumn(value, point = 2) {
    if (XEUtils.isNumber(value)) {
      return fmoney(XEUtils.toNumber(value).toFixed(point), point);
    } else {
      return value;
    }
  },

  // 将数字转换成3位小数（四舍五入）
  formatTableColumnForNum(value) {
    if (XEUtils.isNumber(value)) {
      return fmoney(XEUtils.toNumber(value).toFixed(3));
    } else {
      return value;
    }
  },

  // 判断是否已关联结算批次
  async chkOrderSettle(params = {}) {
    let res = await httpService.post(BASE_API.CHK_ORDERSETTLE, params);
    if (res.data.code == 0 || res.data.code == 10000) {
      return res.data;
    } else {
      alertErr(res.data.msg);
    }
  },

  // 撤销公共方法
  doWithdrawCommon(url, params = {}) {
    return new Promise((resolve, reject) => {
      //撤销前判断是否关联结算批次
      let settleRes = null;
      // if (params['associationType'] && params['associationNoList']) {
      //   settleRes = this.chkOrderSettle(params);
      // }
      let msg = '是否确认撤回？';
      if (settleRes && settleRes.code == 10000) {
        msg = '该单据已关联结算批次，是否确认撤回？';
      }
      confirmBox('确认更改？', msg)
        .then(async () => {
          this.loading.startLoading();
          let res = await httpService.post(url, params);
          loading.endLoading();
          if (res.data.code == 0) {
            // return res.data;
            resolve(res.data);
          } else {
            reject();
            alertErr(res.data.msg);
          }
        })
        .catch(() => {
          reject();
          this.$message({ showClose: true, type: 'info', message: '已取消！' });
        });
    });
  },
  // 根据现有数据返回最新行号  分支测试
  getNewDetailNo(xTable, key) {
    let rows = xTable.getTableData().fullData;
    let removeRow = xTable.getRemoveRecords();
    removeRow = removeRow.filter((item) => item.id); //获取已删除并已存库中的数据
    rows = rows.concat(removeRow);
    let value =
      rows.length != 0
        ? Math.max.apply(
            Math,
            rows.map((item) => item[key])
          )
        : 0;
    return value + 1;
  },

  //根据传入的日期时间返回月初时间
  getBeginOfMonth(date) {
    return dateFormatter(XEUtils.getWhatMonth(date, 0, 'first'));
  },

  // 财务模块，系统配置，Y则是海宁，传参：例应收票据code="BILL_YS_HN",companyCode=#新增时所选部门代码#
  async getSysConfigByCompany(params = {}) {
    let res = await httpService.get(SYSCONFIG_API.GET_SYSCONFIG_BY_COMPANY, params);
    if (res) {
      return res.data;
    }
  },

  // 业务模块，系统配置，Y则是海宁，传参：code="",departmentCode=#新增时所选部门代码#
  async getSysConfigByDepart(params = {}) {
    let res = await httpService.get(SYSCONFIG_API.GET_SYSCONFIG_BY_DEPART, params);
    if (res) {
      return res.data;
    }
  },

  // 判断是否拥有海宁权限
  async hasHnPer() {
    let params = {
      id: store.state.userInfo.userInfo.userCode,
      userCode: store.state.userInfo.userInfo.userCode,
    };
    let hasCompany = await httpService.post(BASE_API.GET_PERSON_API, params);
    hasCompany = hasCompany.data.data.personCompanyInfo;
    let hasCompanyFlag = false;
    if (hasCompany) {
      hasCompany = hasCompany.map((item) => item.personCompanyCode);
      hasCompanyFlag = hasCompany.includes(globalVar.subserver.companyCode);
    }
    return hasCompanyFlag;
  },

  // 获取合作伙伴类型
  async getPartnerType(params = {}) {
    let result = await httpService.post(BASE_API.GET_PARTNER_TYPE, params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.msg;
    } else {
      alertErr('获取合作伙伴类型失败，' + result.data.msg);
    }
    return msg;
  },
  // 获取物流实时库存
  async getCenterList(params = {}) {
    let result = await httpService.post(LOGISTICS.REAL_TIME_STOCK, params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('获取列表失败，' + result.data.msg);
    }
    return msg;
  },
  // 物流库存明细列表
  async getLogisticsList(params = {}) {
    let result = await httpService.post(LOGISTICS.LOGISTICS_STOCK, params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('获取列表失败，' + result.data.msg);
    }
    return msg;
  },
  // 导出物流实时库存
  async exportStock(params = {}) {
    let result = await httpService.post(LOGISTICS.REAL_TIME_EXPORT, params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('导出失败，' + result.data.msg);
    }
    return msg;
  },
  // 导出物流实时库存
  async exportLogistics(params = {}) {
    let result = await httpService.post(LOGISTICS.LOGISTICS_EXPORT, params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('导出失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-功能模块列表
  async functionalModList(params = {}) {
    let result = await httpService.post('/financial/tAeApplication/queryList', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-功能模块列表批量删除
  async delFunctionalModList(params) {
    let result = await httpService.post('/financial/tAeApplication/batchDelete', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-功能模块列表批量新增保存
  async addFunctionalModList(params) {
    let result = await httpService.post('/financial/tAeApplication/batchSave', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.code;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-单据定义列表
  async billDefinitionList(params) {
    let result = await httpService.post('/financial/tAeEntity/queryPage', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-单据定义-事件列表
  async eventList(params) {
    let result = await httpService.post('/financial/tAeEvent/queryList', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
  // 会计引擎-单据定义-新增保存
  async addBill(params) {
    let result = await httpService.post('/financial/tAeEntity/save', params);
    let msg = '';
    if (0 == result.data.code) {
      msg = result.data.data;
    } else {
      alertErr('查询失败，' + result.data.msg);
    }
    return msg;
  },
};
